import { API_URLS } from "../../../config/apiUrls";
import axiosInstance from "../../../config/axios";

export const addSpecificationByExcal = (reqBody) => {
    try {
        const response = axiosInstance.post(API_URLS.add_specification, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};
export const addSpecificationTypesByExcal = (reqBody) => {
    try {
        const response = axiosInstance.post(API_URLS.add_specification_value, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};